import { agreementTemplateFormToQuery as formToQuery } from './agreementTemplateFormToQuery';
import {
  agreementTemplateQueryToForm as queryToForm,
  agreementTemplateQueryToFormItem as queryToFormItem,
  agreementTemplateQueryToParagraphForm as queryToParagraphForm,
  agreementTemplateQueryToParagraphFormItem as queryToParagraphFormItem,
} from './agreementTemplateQueryToForm';

export default {
  formToQuery,
  queryToForm,
  queryToFormItem,
  queryToParagraphForm,
  queryToParagraphFormItem,
};
